module.exports = __webpack_public_path__ + "static/img/lightRound.eddd3716.png";